import { IVisibilityFilter } from 'src/interfaces/PageBlock';

export type VisibilityPresetId =
  | 'signupOpen'
  | 'signupOpenWithEdition'
  | 'signupOpenGuest'
  | 'signupOpenLoggedIn'
  | 'signupClosed';

export const VISIBILITY_PRESETS: Record<VisibilityPresetId, IVisibilityFilter> = {
  signupOpen: {
    rules: [
      { predicate: 'beforeSignupDeadline', expected: true },
      { predicate: 'isSignupOpen', expected: true },
    ],
    connectors: ['and'],
  },
  signupOpenWithEdition: {
    rules: [
      { predicate: 'activeEdition', expected: true },
      { predicate: 'beforeSignupDeadline', expected: true },
      { predicate: 'isSignupOpen', expected: true },
    ],
    connectors: ['and', 'and'],
  },
  signupOpenGuest: {
    rules: [
      { predicate: 'beforeSignupDeadline', expected: true },
      { predicate: 'isSignupOpen', expected: true },
      { predicate: 'userLoggedIn', expected: false },
    ],
    connectors: ['and', 'and'],
  },
  signupOpenLoggedIn: {
    rules: [
      { predicate: 'beforeSignupDeadline', expected: true },
      { predicate: 'isSignupOpen', expected: true },
      { predicate: 'userLoggedIn', expected: true },
    ],
    connectors: ['and', 'and'],
  },
  signupClosed: {
    rules: [
      { predicate: 'isSignupOpen', expected: false },
      { predicate: 'beforeSignupDeadline', expected: false },
    ],
    connectors: ['or'],
  },
};
